import _toConsumableArray from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { interpolate, defaultOffset } from '@motionone/utils';
import { calcInset } from './inset.es.js';
import { ScrollOffset } from './presets.es.js';
import { resolveOffset } from './offset.es.js';
var point = {
  x: 0,
  y: 0
};
function resolveOffsets(container, info, options) {
  var _options$offset = options.offset,
    offsetDefinition = _options$offset === void 0 ? ScrollOffset.All : _options$offset;
  var _options$target = options.target,
    target = _options$target === void 0 ? container : _options$target,
    _options$axis = options.axis,
    axis = _options$axis === void 0 ? "y" : _options$axis;
  var lengthLabel = axis === "y" ? "height" : "width";
  var inset = target !== container ? calcInset(target, container) : point;
  /**
   * Measure the target and container. If they're the same thing then we
   * use the container's scrollWidth/Height as the target, from there
   * all other calculations can remain the same.
   */
  var targetSize = target === container ? {
    width: container.scrollWidth,
    height: container.scrollHeight
  } : {
    width: target.clientWidth,
    height: target.clientHeight
  };
  var containerSize = {
    width: container.clientWidth,
    height: container.clientHeight
  };
  /**
   * Reset the length of the resolved offset array rather than creating a new one.
   * TODO: More reusable data structures for targetSize/containerSize would also be good.
   */
  info[axis].offset.length = 0;
  /**
   * Populate the offset array by resolving the user's offset definition into
   * a list of pixel scroll offets.
   */
  var hasChanged = !info[axis].interpolate;
  var numOffsets = offsetDefinition.length;
  for (var i = 0; i < numOffsets; i++) {
    var offset = resolveOffset(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
    if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) {
      hasChanged = true;
    }
    info[axis].offset[i] = offset;
  }
  /**
   * If the pixel scroll offsets have changed, create a new interpolator function
   * to map scroll value into a progress.
   */
  if (hasChanged) {
    info[axis].interpolate = interpolate(defaultOffset(numOffsets), info[axis].offset);
    info[axis].interpolatorOffsets = _toConsumableArray(info[axis].offset);
  }
  info[axis].progress = info[axis].interpolate(info[axis].current);
}
export { resolveOffsets };